// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"backdrop_backdrop___uG7z","not-clickable":"backdrop_not-clickable__PO_XW"};